import { render, staticRenderFns } from "./CardiomiopatieViewComponent.vue?vue&type=template&id=fc9dd6f8"
import script from "./CardiomiopatieViewComponent.vue?vue&type=script&lang=js"
export * from "./CardiomiopatieViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports